import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/permisosDeAcceso/groups";
import groups from "../../models/permisosDeAcceso/groups";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    groups: [],
    new: [],
    edit: [],
    deleteItem: [],
    showAdd: false,
    permissionId: null,
    openGroup: false,
    mode: "",
    openDelete: false,
  },

  mutations: {
    setGroups(state, data) {
      state.groups = data;
    },

    setEdit(state, data) {
      state.edit = data;
    },

    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setShowAdd(state, data) {
      state.showAdd = data;
    },

    setNew(state, data) {
      state.new = data;
    },
    setOpenGroup(state, data) {
      state.openGroup = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setPermissionId(state, data) {
      state.permissionId = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
  },
  actions: {
    async getGroups(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getGroups(
            state.state.permissionId
          );

          state.commit("setGroups", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.edit).then(() => {
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async new(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.new(state.state.new).then(({ data }) => {
            state.dispatch("getGroups");
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.deleteItem).then(() => {
            let options = state.state.groups;
            options = options.filter((option) => {
              return option.id != state.state.deleteItem.id;
            });
            state.commit("setGroups", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
